import { createContext } from "react";

const AccessContext = createContext({ accessFunctions: new Map() });

export default AccessContext;
